import React, { useEffect, useRef, useCallback } from 'react';

const CardContainer = ({ children, ignoreMatchHeight = false }) => {
  const containerRef = useRef(null);

  const matchCardHeights = useCallback(() => {
    if (!containerRef.current || ignoreMatchHeight) return;

    const cards = containerRef.current.querySelectorAll('.card');
    let maxHeight = 0;

    // reset heights first
    cards.forEach(card => (card.style.height = 'auto'));

    // find tallest
    cards.forEach(card => {
      if (card.offsetHeight > maxHeight) maxHeight = card.offsetHeight;
    });

    // set all to tallest
    cards.forEach(card => (card.style.height = `${maxHeight}px`));
  }, [ignoreMatchHeight]);

  useEffect(() => {
    matchCardHeights();
    window.addEventListener('resize', matchCardHeights);
    return () => window.removeEventListener('resize', matchCardHeights);
  }, [children, matchCardHeights]);

  return (
    <div className="card-container-wrapper">
      <div className="card-container" ref={containerRef}>
        {children}
      </div>
    </div>
  );
};

export default CardContainer;
